<template>
  <div>
    <TableHeader 
      :title="title || 'لیست سوابق حواله ها'" 
      @updateSelect="(e) => headersSelected = e" 
      :notExcl="notExcl"
      :notFilter="notFilter"
      :exc-data="remittanceHistory" 
      :filter-headers="headers" 
      :filter-headers-select="headersSelected" 
      :exc-columns="columns" 
      v-model="search" 
      />
    <v-data-table
      :headers="headersSelected"
      :items="remittanceHistory"
      :search="search"
      :hide-default-footer="!showPages"
      :items-per-page="per_page"
      :loading="loading"
    >
      <template v-slot:item.type="{ item }">
        {{ item.factory_id != null ? "اشخاص" : "شرکت" }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ translate(item.status) }}
      </template>
      <template v-slot:item.plaque="{ item }">
        <Plaque :plaque="item.plaque" />
      </template>
      <template v-slot:item.driver.plaque="{ item }">
        <Plaque :plaque="item.plaque" />
      </template>
      <template v-slot:item.nameFamily="{ item }">
        {{ item.driver.name + " " + item.driver.family }}
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ getPersianDate(item.created_at) }}
      </template>
      <template v-slot:item.updated_at="{ item }">
        {{ getPersianDate(item.updated_at) }}
      </template>
      <template v-slot:item.rent="{ item }">
        {{ Seprate(item.rent) }}
      </template>
      <template v-slot:item.bime="{ item }">
        {{ item.bime ? Seprate(item.bime) : "-" }}
      </template>
      <template v-slot:item.baseFare="{ item }">
        {{ item.baseFare ? Seprate(item.baseFare) : "-" }}
      </template>
      <template v-slot:item.avarez="{ item }">
        {{ item.avarez ? Seprate(item.avarez) : "-" }}
      </template>
      <template v-slot:item.commission="{ item }">
        {{ item.commission ? Seprate(item.commission) : "-" }}
      </template>
      <template v-slot:item.operations="{ item }">
        <slot :item="item" :mmd="'byyyyeee'" ></slot>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Plaque from "@/components/Plaque.vue";
import TableHeader from "@/components/Table/TableHeader.vue";

// import TableHeader from "@/components/table/tableHeader.vue";

export default {
  props: ["remittanceHistory", "per_page", "showPages", "title", "isCustom", 'customHeaders', "notExcl", "notFilter"],
  components: { Plaque, TableHeader },
  data() {
    return {
      loading: false,
      search: "",
      headersSelected: [
        { text: "شناسه", value: "id" },
        { text: "اعلام بار توسط", value: "type" },
        { text: "وضعیت", value: "status" },
        { text: "نام و فامیل", value: "nameFamily" },
        { text: "کرایه کل به ریال", value: "rent" },
        { text: "کرایه پایه", value: "baseFare" },
        { text: "بیمه", value: "bime" },
        { text: "عوارض", value: "avarez" },
        { text: "کمیسیون شرکت", value: "commission" },
        { text: "شماره ملی", value: "driver.nationalId" },
        { text: "تاریخ", value: "created_at" },
        { text: "پلاک", value: "plaque" },
        { text: "نوع ماشین", value: "carTypeTitle" },
        { text: "نام شرکت", value: "company.company_name" },
        { text: "عملیات", value: "operations" },
      ],
      headers: [
        { text: "شناسه", value: "id", status: true },
        { text: "وضعیت", value: "status", status: true },
        { text: "نام و فامیل", value: "nameFamily", status: true },
        { text: "کرایه کل به ریال", value: "rent", status: true },
        { text: "کرایه پایه", value: "baseFare", status: true },
        { text: "بیمه", value: "bime", status: true },
        { text: "عوارض", value: "avarez", status: true },
        { text: "کمیسیون شرکت", value: "commission", status: true },
        { text: "شماره ملی", value: "driver.nationalId", status: true },
        { text: "تاریخ", value: "created_at", status: true },
        { text: "پلاک", value: "plaque", status: true },
        { text: "نوع ماشین", value: "carTypeTitle", status: true },
        { text: "نام شرکت", value: "company.company_name", status: true },
        { text: "عملیات", value: "operations", status: true },
      ],
      columns: [
        { label: "شناسه", field: "id" },
        { label: "وضعیت", field: "status" },
        { label: "نام و فامیل", field: "nameFamily" },
        { label: "کرایه کل به ریال", field: "rent" },
        { label: "کرایه پایه", field: "baseFare" },
        { label: "بیمه", field: "bime" },
        { label: "عوارض", field: "avarez" },
        { label: "کمیسیون شرکت", field: "commission" },
        { label: "شماره ملی", field: "driver.nationalId" },
        { label: "تاریخ", field: "created_at" },
        { label: "پلاک", field: "plaque" },
        { label: "نوع ماشین", field: "carTypeTitle" },
        { label: "نام شرکت", field: "company.company_name" },
      ],
    };
  },
  methods: {
    handelHeaders(){
      if (this.isCustom) {
        this.headersSelected = [...this.customHeaders]
      }
    },
  },  
  mounted(){
    this.handelHeaders()
  }
};
</script>

<style lang="scss" scoped></style>
